module.exports = __webpack_public_path__ + "static/media/right-arrow.f70141bf.svg";